import i18n from 'i18next';
export { default } from 'i18next';
import data from "./locales/data.js";
i18n.init({
  lng: 'en',
  resources: data
});